import { useEffect, useState } from "react";

export const useKeyboardModifiers = (isEnabled) => {
	const [shiftOn, setShiftOn] = useState(false);
	const [ctrlOn, setCtrlOn] = useState(false);

	const keyDownFn = (e) => {
		if (e.key === "Shift") {
			setShiftOn(true);
		} else if (e.key === "Control") {
			setCtrlOn(true);
		}
	};

	const keyUpFn = (e) => {
		if (e.key === "Shift") {
			setShiftOn(false);
		} else if (e.key === "Control") {
			setCtrlOn(false);
		}
	};

	useEffect(() => {
		if (isEnabled) {
			document.addEventListener("keydown", keyDownFn);
			document.addEventListener("keyup", keyUpFn);

			return () => {
				document.removeEventListener("keydown", keyDownFn);
				document.removeEventListener("keyup", keyUpFn);
			};
		}
	}, [isEnabled]);

	return { shiftOn, ctrlOn };
};

